import React, {useEffect} from 'react';

import "./PDSADoTabTwo.css";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {NextButton} from "../../../../../../common/button/next-button/NextButton";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";

export const PdsaDoTabTwo = ({
                                 setActiveTab,
                                 setCurrentScreen,
                                 context,
                                 PDSA,
                                 setPDSA,
                                 navigateTo,
                                 savePDSA,
                                 active,
                                 setSpinnerText,
                                 showToaster,
                                 toolTipsEnabled
                             }) => {

    useEffect(() => {
        setActiveTab("do");
    }, []);

    const isButtonDisabled = () => {
        return !PDSA.observation;
    }

    const handleNextClick = () => {
        if (active) {
            savePDSA(() => {
                setCurrentScreen("PDSAStudyTabOne");
            })
        } else {
            setCurrentScreen("PDSAStudyTabOne");
        }
    }

    return (
        <div className="do-tab-two-container">
            <div className="input-container">
                <div>
                    <label>Observation:</label>
                    {toolTipsEnabled &&
                    <ToolTip tooltipExternalReference={"pdsaObservation123"}
                             context={context}
                             setSpinnerText={setSpinnerText} showToaster={showToaster}
                             fieldName={"Observation:"}/>}
                </div>
                <textarea defaultValue={PDSA.observation ? PDSA.observation : null}
                          disabled={!active || !context.editMode}
                          onChange={({target}) => {
                              setPDSA((prevState) => ({
                                  ...prevState,
                                  observation: target.value
                              }));
                          }}/>
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview" onClick={() => {
                    navigateTo("problemTree");
                }}/>
            </div>
            <div className="pdsa-navigation-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSADoTabOne")
                }}/>
                <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
            </div>
        </div>
    );
}
